import type { PackageLifecycleState } from '@/lib/types/lifecycle'

const STYLES: Record<PackageLifecycleState, string> = {
  staging:
    'ring-muted-foreground/30 text-muted-foreground bg-muted/40',
  live:
    'ring-primary/40 text-primary bg-primary/10',
  quarantined:
    'ring-amber-500/40 text-amber-500 bg-amber-500/10',
  deprecated:
    'ring-muted-foreground/30 text-muted-foreground/80 bg-muted/30',
  blacklisted:
    'ring-destructive/40 text-destructive bg-destructive/10',
  deleted:
    'ring-muted-foreground/30 text-muted-foreground/60 bg-muted/30 line-through',
  purged:
    'ring-muted-foreground/20 text-muted-foreground/40 bg-muted/20 line-through',
}

export function StateBadge({
  state,
  size = 'sm',
}: {
  state: PackageLifecycleState
  size?: 'xs' | 'sm'
}) {
  const sizing =
    size === 'xs'
      ? 'text-[9px] px-1.5 py-0.5 tracking-[0.18em]'
      : 'text-[10px] px-2 py-0.5 tracking-[0.22em]'
  return (
    <span
      className={`inline-flex items-center font-mono uppercase rounded-sm ring-1 ring-inset ${sizing} ${STYLES[state]}`}
    >
      {state}
    </span>
  )
}

export function StateCounts({
  counts,
}: {
  counts: {
    staging_count: number
    live_count: number
    quarantined_count: number
    deprecated_count: number
    blacklisted_count: number
    deleted_count?: number
    purged_count?: number
  }
}) {
  const entries: Array<[PackageLifecycleState, number]> = [
    ['live', counts.live_count],
    ['staging', counts.staging_count],
    ['quarantined', counts.quarantined_count],
    ['deprecated', counts.deprecated_count],
    ['blacklisted', counts.blacklisted_count],
    ['deleted', counts.deleted_count ?? 0],
    ['purged', counts.purged_count ?? 0],
  ]
  return (
    <div className="flex gap-1 items-center">
      {entries
        .filter(([, n]) => n > 0)
        .map(([state, n]) => (
          <span
            key={state}
            className={`inline-flex items-center gap-1 font-mono text-[10px] uppercase rounded-sm ring-1 ring-inset px-1.5 py-0.5 ${STYLES[state]}`}
          >
            <span className="tabular-nums">{n}</span>
            <span className="tracking-[0.18em]">{state}</span>
          </span>
        ))}
    </div>
  )
}
